"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ThemeFontStyleTypeEnum;
(function (ThemeFontStyleTypeEnum) {
    ThemeFontStyleTypeEnum["bodySmall"] = "bodySmall";
    ThemeFontStyleTypeEnum["bodyMedium"] = "bodyMedium";
    ThemeFontStyleTypeEnum["bodyLarge"] = "bodyLarge";
    ThemeFontStyleTypeEnum["bodyXLarge"] = "bodyXLarge";
    ThemeFontStyleTypeEnum["headingXSmall"] = "headingXSmall";
    ThemeFontStyleTypeEnum["headingSmall"] = "headingSmall";
    ThemeFontStyleTypeEnum["headingMedium"] = "headingMedium";
    ThemeFontStyleTypeEnum["headingLarge"] = "headingLarge";
    ThemeFontStyleTypeEnum["headingXLarge"] = "headingXLarge";
    ThemeFontStyleTypeEnum["priceMedium"] = "priceMedium";
    ThemeFontStyleTypeEnum["priceLarge"] = "priceLarge";
})(ThemeFontStyleTypeEnum || (ThemeFontStyleTypeEnum = {}));
exports.default = ThemeFontStyleTypeEnum;
//# sourceMappingURL=ThemeFontStyleTypeEnum.js.map